import React from 'react';

class SubmitButton extends React.Component {
	render() {
		const title = this.props.title || 'Submit';

		return (
			<div style={{
				position: 'relative',
				height: '100%'
			}}>
				<div style={{
					position: 'absolute',
					left: 8,
					right: 8,
					top: 8,
					bottom: 8,
					backgroundColor: '#0078FF',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					borderRadius: 4,
					overflow: 'hidden'
				}} onClick={this.props.onClick} className="pointer">
					<div style={{
						color: '#FFFFFF',
						fontSize: 16,
						fontWeight: 600
					}}>
						{title}
					</div>
				</div>
			</div>
		);
	}
}

export default SubmitButton;


// WEBPACK FOOTER //
// ./src/components/submitbutton.jsx